import { RegularDrawdownClient } from "../../../../../../Wrap/Api/Drawdown/RegularDrawdown";
import { RegularDrawdown } from "../../../../../../Wrap/Models/Domains/Drawdown/RegularDrawdown";
import { ActionType } from "../../../../../../react-core/Flux/ActionType";
import { ExistingRegularCryDispatcher } from "../../EditIncomeDrawdownWizard/Stores/Variable";

export class GetRegularCrystallisationAction {
  public static getRegularCrystallisation(hierarchyId: string, onSuccess: (result: RegularDrawdown) => void, onError?: (error) => void) {
    const client = new RegularDrawdownClient();
    const promise = client.get(hierarchyId);
    promise.onSuccess((result) => {
            ExistingRegularCryDispatcher.dispatch({
            actionType: ActionType.Success,
            payload: result,
        });
      onSuccess(result)});
    promise.onError((error) => {if (onError) {onError(error)}});
  }
}
